import ReactCropper from 'react-easy-crop';
import type { Point, Area } from 'react-easy-crop';
import { CROPPER_DIMENSIONS } from '@/constants/cropper';

interface CropperCanvasProps {
  imageUrl: string;
  crop: Point;
  zoom: number;
  aspectRatio: number;
  onCropChange: (crop: Point) => void;
  onZoomChange: (zoom: number) => void;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
}

/**
 * CropperCanvas Component
 * 
 * Renders the interactive cropping area
 */
export function CropperCanvas({
  imageUrl,
  crop,
  zoom,
  aspectRatio,
  onCropChange,
  onZoomChange,
  onCropComplete,
}: CropperCanvasProps) {
  return (
    <div className={`relative ${CROPPER_DIMENSIONS.HEIGHT_CLASS} bg-black`}>
      {imageUrl && (
        <ReactCropper
          image={imageUrl}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropComplete}
          objectFit="contain"
        />
      )}
    </div>
  );
}

